import { TiltCard } from './ui/tilt-card';

export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-start">
          {/* Image */}
          <div className="order-2 md:order-1 flex flex-col items-center w-full max-w-full">
            {/* Animated instruction */}
            <div className="mb-3 sm:mb-4 animate-bounce flex flex-col items-center gap-1">
              <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-medium shadow-lg whitespace-nowrap">
                ✨ Hover to interact
              </div>
              <svg className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
              </svg>
            </div>

            <div className="w-full max-w-full aspect-square">
              <TiltCard
                src="./images/profile-picture.jpg"
                alt="Alberto Menendez"
                className="w-full h-full"
              />
            </div>
          </div>

          {/* Content */}
          <div className="order-1 md:order-2">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              About Me
            </h2>

            <div className="space-y-4 text-gray-700 text-base md:text-lg">
              <p>
                I'm currently pursuing my MBA at <span className="font-semibold text-blue-600">MIT Sloan School of Management</span>,
                focusing on Product Management and Entrepreneurship.
              </p>

              <p>
                Previously, I worked as a <span className="font-semibold">Cloud Deployed Engineer at AWS</span>, where I delivered
                cloud projects for Fortune 500 companies across Financial, Automotive, and Telco sectors. I specialized in
                DevOps, Infrastructure, MLOps, and AI solutions.
              </p>

              <p>
                I hold a <span className="font-semibold">Double Master's degree in Industrial Technologies & Smart Industry</span> from
                Comillas University in Madrid, graduating in the top 3% of my class with the best master's thesis award.
              </p>

              <p>
                I'm passionate about building innovative technology solutions that make a real impact, combining my technical
                background with business strategy and product thinking.
              </p>
            </div>

            {/* Quick Facts */}
            <div className="mt-8 grid grid-cols-2 gap-4">
              <div className="bg-blue-50 p-4 rounded-lg">
                <div className="text-3xl font-bold text-blue-600">6+</div>
                <div className="text-sm text-gray-600">Cloud Projects Delivered</div>
              </div>
              <div className="bg-blue-50 p-4 rounded-lg">
                <div className="text-3xl font-bold text-blue-600">4</div>
                <div className="text-sm text-gray-600">Languages Spoken</div>
              </div>
              <div className="bg-blue-50 p-4 rounded-lg">
                <div className="text-3xl font-bold text-blue-600">4</div>
                <div className="text-sm text-gray-600">AWS Blog Posts</div>
              </div>
              <a href="https://www.credly.com/users/alberto-menendez.ac26ae8f" target="_blank" rel="noopener noreferrer" className="bg-blue-50 p-4 rounded-lg hover:bg-blue-100 transition block">
                <div className="text-3xl font-bold text-blue-600">6</div>
                <div className="text-sm text-gray-600">AWS Certifications</div>
              </a>
              <div className="bg-blue-50 p-4 rounded-lg">
                <div className="text-3xl font-bold text-blue-600">10+</div>
                <div className="text-sm text-gray-600">Team Members Mentored</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
